import React, { useEffect, useState } from 'react';
import copy from 'copy-to-clipboard';
import { cloneDeep } from 'lodash-es';
import {
    Badge,
    Banner,
    BlockStack,
    Box,
    Button,
    Checkbox,
    Collapsible,
    Icon,
    InlineStack,
    Link,
    Modal,
    RadioButton,
    Scrollable,
    SkeletonBodyText,
    SkeletonDisplayText,
    Text,
    Tooltip,
} from '@shopify/polaris';
import {
    AdjustIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    CollectionIcon,
    DuplicateIcon,
    HomeIcon,
    MobileIcon,
    NoteIcon,
    PlayCircleIcon,
    QuestionCircleIcon,
    SocialPostIcon,
    StarIcon,
    TextBlockIcon,
    WrenchIcon,
    MagicIcon,
} from "@shopify/polaris-icons";
import Language from '../../../../../i18n/Language';
import {
    reqSelectAuditAnalysisIntents,
} from '../../../../../api';
import CopyIcon from '../../../../../assets/CopyIcon';
const t = Language;
const MAX_INTENT_COUNT = 3; // 意图默认最多显示数量

const SearchIntent = (props) => {
    const {
        recordId,
        specialTaskLoading,
        intentLoading,
        toggleToast,
        intentResData,
        sourceType,
        id,
        isShowCompetitorsModal,
    } = props;

    const [intentRes, setIntentRes] = useState(null);
    const [selectCompetitorsModalState, setSelectCompetitorsModalState] = useState(false);
    const [selectedIntentData, setSelectedIntentData] = useState({});
    const [selectedIntentId, setSelectedIntentId] = useState(-1);
    const [selectLensState, setSelectLensState] = useState('');
    const [selectArticleList, setSelectArticleList] = useState([]);
    const [articleList, setArticleList] = useState([]);
    const [artSelectModalArr, setArtSelectModalArr] = useState([]);
    const [artSelectArr, setArtSelectArr] = useState([]);
    // const [includesRecommendState, setIncludesRecommendState] = useState(false);
    const [isDifferentInit, setIsDifferentInit] = useState(false);
    const [intentData, setIntentData] = useState([]);
    const [intentExpanded, setIntentExpanded] = useState(false); // 意图是否展开全部
    const [competitorsWebIds, setCompetitorsWebIds] = useState([]);
    const [researchOpenCompetitorId, setResearchOpenCompetitorId] = useState(null);
    const [switchTopicTipState, setSwitchTopicTipState] = useState(false);
    const [storageTopicId, setStorageTopicId] = useState(-1); // 存储主题id
    const [isChangeArticle, setIsChangeArticle] = useState(false); // 是否切换文章
    const [outSelectLensState, setOutSelectLensState] = useState(false); // 选择文章数量不足提示模式
    const [paaData, setPaaData] = useState([]);
    const [intentBlockLoading, setIntentBlockLoading] = useState(true);
    const [saveAndReAnalyzeLoading, setSaveAndReAnalyzeLoading] = useState(false);
    const [specialLoading, setSpecialLoading] = useState(false);
    const [pageSign, setPageSign] = useState({
        sourceType: '',
        id: -1,
    });
    // 排序文章列表
    const sortArticleList = (list = [], idArr = []) => {
        let selectArr = list.filter(item => idArr.includes(item.id));
        let notSelectArr = list.filter(item => !idArr.includes(item.id));
        notSelectArr.sort((a, b) => a.position - b.position);
        let _sortArr = [...selectArr, ...notSelectArr];
        return _sortArr;
    };

    useEffect(() => {
        setPageSign({
            sourceType,
            id,
        })
    }, [sourceType, id]);

    useEffect(() => {
        if (isShowCompetitorsModal) {
            setSelectCompetitorsModalState(true);
        }
    }, [isShowCompetitorsModal]);

    useEffect(() => {
        props.updCompetitorsModalState(selectCompetitorsModalState);
    }, [selectCompetitorsModalState]);

    // 获取意图数据
    const getIntentData = async (data = null) => {
        const res = data;
        setIntentRes(res);
        if (res?.ack === 1) {
            const _t = res.data;
            let _list = _t?.intents || [];      // 意图数据
            setIntentData(_list);
            let _selectArr = (_t.selected_web_ids).slice(0, 5);   // 选择的文章id数组
            // 需要判断选择文章是在哪个意图下, 不存在选择推荐
            let c_obj = _t?.selected_intent_id ? _list.find(item => item.id === _t.selected_intent_id) : _list.find(item => item.type === 1) || {};  // 推荐意图数据
            // 设置
            setSelectedIntentData(c_obj);
            setSelectedIntentId(c_obj?.id);
            setStorageTopicId(c_obj?.id);
            // 选中意图不在前 4 个时默认展开
            setIntentExpanded(_list.findIndex(item => item.id === c_obj?.id) >= MAX_INTENT_COUNT);

            let _articleList = _list.map(item => (item?.websites || [])).flat();
            // let _selectArr = c_obj.websites.map(item => item.id).slice(0, 5);
            let _sortArr = sortArticleList(_articleList, _selectArr);
            setArticleList(_articleList);   // 总网站列表
            setSelectArticleList(_sortArr); // 选择文章列表
            setArtSelectArr(_selectArr);
            setArtSelectModalArr(_selectArr);
            setCompetitorsWebIds(_selectArr); // 选择分析的文章
            // setIncludesRecommendState(c_obj.websites.some(item => _selectArr.includes(item.id)));
            // 获取PAA数据
            setPaaData(_t.paa);
        }
    };

    // 取消切换
    const handleCancelSwitchTopic = () => {
        setStorageTopicId(-1);
        setSwitchTopicTipState(false);
    }

    // 确认切换
    const handleSwitchTopic = (id) => {
        setSelectedIntentId(id);
        setSwitchTopicTipState(false);
        // 切换选择文章数组
        let _topicData = intentData.find(item => item.id === id);
        let _selectArr = (_topicData?.websites || []).map(item => item.id).slice(0, 5);
        setArtSelectArr(_selectArr);
        setArtSelectModalArr(_selectArr);
        setSelectLensState(_selectArr.length < 2 ? 'litter' : '');
        setIsChangeArticle(false);
        // 排序
        let _sortArr = sortArticleList(articleList, _selectArr);
        setSelectArticleList(_sortArr);
        setOutSelectLensState(Boolean(_selectArr.length < 2));
    }

    // 选择意图
    const handleSelectIntent = (topicId) => {
        // 不重复操作
        if (topicId === selectedIntentId) return;
        // 判断是否提示
        setStorageTopicId(topicId);
        if (isChangeArticle) {
            setSwitchTopicTipState(true);
        } else {
            setSelectedIntentId(topicId);
            handleSwitchTopic(topicId);
        }
    };

    // 选择竞争对手弹窗
    const handleSelectCompetitorsModal = () => {
        setSelectCompetitorsModalState(true);
    };

    // 内联切换参考文章（无需打开弹窗）
    const handleToggleReferenceArticle = (val) => {
        let _selectArr = cloneDeep(artSelectArr);
        if (artSelectArr.includes(val)) {
            _selectArr = artSelectArr.filter(id => id !== val);
        } else {
            _selectArr = [...artSelectArr, val];
        }
        setArtSelectArr(_selectArr);
        setArtSelectModalArr(_selectArr);
        setIsChangeArticle(true);
        setIsDifferentInit(true);
        // 校验选择数量
        if (_selectArr.length < 2) {
            setSelectLensState('litter');
        } else if (_selectArr.length > 5) {
            setSelectLensState('more');
        } else {
            setSelectLensState('');
        }
        setOutSelectLensState(Boolean(_selectArr.length < 2));
    };

    // 参考文章选择是否有效
    const getReferenceInvalid = () => {
        return artSelectArr.length < 2 || artSelectArr.length > 5;
    };

    // 复制研究意图
    const handleCopyResearchIntent = () => {
        const paaLines = paaData.map((q) => `• ${q}`);
        const text = [
            t('People Also Ask'),
            ...paaLines,
        ].join('\n');
        copy(text);
        toggleToast(t("Copy successfully!"));
    };

    // 复制竞品大纲
    const handleCopyCompetitorOutline = (headingsContent) => {
        let lines = [];
        try {
            lines = JSON.parse(headingsContent).map((item) => Object.values(item)[0]);
        } catch (e) {
            lines = [];
        }
        copy(lines.join('\n'));
        toggleToast(t("Copy successfully!"));
    };

    // 保存并重新分析
    const handleSaveAndReAnalyze = async () => {
        setSaveAndReAnalyzeLoading(true);
        let params = {
            sourceType: pageSign.sourceType,
            id: pageSign.id,
            record_id: recordId,
            intent_id: selectedIntentId,
            web_ids: artSelectArr
        }
        const res = await reqSelectAuditAnalysisIntents(params);
        if (Number(res.code) === 1000) {
            setSelectCompetitorsModalState(false);
            props.handleShowGetMoreUsageModal();
        } else if (res.ack === 1) {
            setSelectCompetitorsModalState(false);
            props.handleRefreshAnalysis();
        } else {
            toggleToast(t(res.msg), true);
        }
        setSaveAndReAnalyzeLoading(false);
    }

    // 输出类型
    const OutIntentType = (type = '') => {
        const typeArr = {
            'Product': { icon: CollectionIcon, title: t('Product') },
            'Collection': { icon: StarIcon, title: t('Collection') },
            'Homepage': { icon: HomeIcon, title: t('Homepage') },
            'Blog Post': { icon: NoteIcon, title: t('Blog Post') },
            'Tool Page': { icon: WrenchIcon, title: t('Tool Page') },
            'Video': { icon: PlayCircleIcon, title: t('Video') },
            'Community': { icon: SocialPostIcon, title: t('Community') },
            'Social': { icon: MobileIcon, title: t('Social') },
            'Other Page': { icon: TextBlockIcon, title: t('Other Page') },
        };
        const _type = Object.keys(typeArr).includes(type) ? type : 'Other Page';
        return <span className='flex_layout' style={{ gap: '2px' }}>
            <span><Icon source={typeArr[_type].icon} tone='base' /></span>
            <span>{t(typeArr[_type].title)}</span>
        </span>;
    };

    // 空模块
    const emptyModule = (text = "") => {
        return <div className='audit_empty_module'>
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_11100_18524)">
                    <rect width="60" height="60" fill="white" />
                    <rect x="36.3108" y="40.373" width="3.7166" height="5.23736" transform="rotate(-47.1295 36.3108 40.373)" fill="#8c9196" />
                    <rect x="38.0867" y="46.082" width="9.29151" height="2.32288" transform="rotate(-47.1295 38.0867 46.082)" fill="#8c9196" />
                    <path d="M39.7893 47.6602L46.1107 40.8505L55.5547 49.6173C57.4352 51.3629 57.5445 54.3024 55.7988 56.1829C54.0532 58.0633 51.1137 58.1726 49.2333 56.427L39.7893 47.6602Z" fill="#8c9196" />
                    <circle cx="23.6486" cy="25.41" r="17.3667" transform="rotate(-10.9199 23.6486 25.41)" stroke="#8c9196" strokeWidth="5.64706" />
                </g>
                <defs>
                    <clipPath id="clip0_11100_18524">
                        <rect width="60" height="60" fill="white" />
                    </clipPath>
                </defs>
            </svg>
            <Text as='p' variant='bodyMd' tone='subdued'>{text ? t(text) : t("No data to show here")}</Text>
        </div>;
    };

    useEffect(() => {
        setIntentBlockLoading(intentLoading);
    }, [intentLoading]);

    useEffect(() => {
        getIntentData(intentResData);
    }, [intentResData]);

    useEffect(() => {
        setSpecialLoading(specialTaskLoading);
    }, [specialTaskLoading]);

    // 切换主题提示弹窗
    const switchTopicTipModal = <Modal
        size="small"
        open={switchTopicTipState}
        title={t("Switch Topic Confirmation")}
        primaryAction={{
            content: t("Clear and Continue"),
            onAction: () => handleSwitchTopic(storageTopicId),
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: handleCancelSwitchTopic,
            }
        ]}
        onClose={handleCancelSwitchTopic}
    >
        <Modal.Section>
            <Text variant="bodyMd" as="p" tone="base">{t("Selecting this topic will clear the articles you've selected and switch to the articles under the new topic. Please confirm to continue.")}</Text>
        </Modal.Section>
    </Modal>

    // 选择竞争对手弹窗
    const SelectCompetitorsModal = <Modal
        open={selectCompetitorsModalState}
        title={t("Select Search Intent & Reference Articles")}
        onClose={() => setSelectCompetitorsModalState(false)}
        primaryAction={{
            content: t("Save and re-analyze"),
            onAction: handleSaveAndReAnalyze,
            loading: saveAndReAnalyzeLoading,
            disabled: Boolean(outSelectLensState || intentData.length === 0 || switchTopicTipState)
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: () => setSelectCompetitorsModalState(false),
                disabled: saveAndReAnalyzeLoading || switchTopicTipState,
            },
        ]}
    >
        <Modal.Section>
            <div className='select_competitors_modal_content'>
                {/* Search Intent 选择（内联，RadioButton） */}
                <div className="sci_section">
                    <div>
                        <div className="flex_layout">
                            <Text variant="headingLg" as="h3" fontWeight="semibold">1. {t("Choose the primary search intent")}</Text>
                        </div>
                        <div className='flex_layout tip_select'>
                            <Text variant="bodyMd" as="p" tone='subdued'>{t("Select the intent that best matches what users are looking for")}</Text>
                        </div>
                    </div>
                    <div className="intent_list">
                        {
                            intentData.length > 0 ? (intentExpanded ? intentData : intentData.slice(0, MAX_INTENT_COUNT)).map(item => (
                                <div
                                    key={item.id}
                                    className={`intent_card ${selectedIntentId === item.id ? 'selected' : ''}`}
                                    onClick={() => handleSelectIntent(item.id)}
                                >
                                    <div className="intent_card_radio" onClick={(e) => e.stopPropagation()}>
                                        <RadioButton
                                            label=""
                                            labelHidden
                                            checked={selectedIntentId === item.id}
                                            onChange={() => handleSelectIntent(item.id)}
                                        />
                                    </div>
                                    <div className="intent_header">
                                        <div className="intent_title_row" style={{ maxWidth: item.type === 1 ? '80%' : '100%' }}>
                                            {
                                                (item.type === 1 && item.intent_label.length > 50) ? <Tooltip
                                                    content={item.intent_label}
                                                >
                                                    <Text variant="headingMd" as="h3" fontWeight="semibold">{item.intent_label.slice(0, 45)}...</Text>
                                                </Tooltip> : <Text variant="headingMd" as="h3" fontWeight="semibold">{item.intent_label}</Text>
                                            }
                                            {/* <Badge tone="success">{(Number(item.percentage) * 100).toFixed(0) || 0}%</Badge> */}
                                            <div className='intent_type_badge'>
                                                <Tooltip content={t("The most common page type for this intent. Use this format to maximize your ranking potential.")}>
                                                    <Badge>{OutIntentType(item?.dominant_page_type || '')}</Badge>
                                                </Tooltip>
                                            </div>
                                            {item.type === 1 && (
                                                <span className="intent_recommended_badge">
                                                    <span><Icon source={MagicIcon} /></span>
                                                    <span>{t("Recommended")}</span>
                                                </span>
                                            )}
                                        </div>
                                        <Text variant="bodyMd" as="p" tone="subdued">{item.intent_summary}</Text>
                                    </div>
                                </div>
                            )) : emptyModule("No data to show here")
                        }
                    </div>
                    {
                        intentData.length > MAX_INTENT_COUNT && <div className="intent_view_more">
                            <button type="button" onClick={() => setIntentExpanded(!intentExpanded)}>
                                <span>{intentExpanded ? t("View less") : t("View more")}</span>
                                <Icon source={intentExpanded ? ChevronUpIcon : ChevronDownIcon} />
                            </button>
                        </div>
                    }
                </div>

                {/* 分割线 */}
                <div className="sbt_divider"></div>

                {/* Reference articles 选择（内联，Checkbox，无需再打开弹窗） */}
                <div className="sci_section">
                    <div>
                        <div className="flex_layout">
                            <Text variant="headingLg" as="h3" fontWeight="semibold">2. {t("Select reference sources")}</Text>
                        </div>
                        <div className='flex_layout tip_select'>
                            <Text variant="bodyMd" as="p" tone='subdued'>{t("Select relevant sources to guide the content recommendations.")}</Text>
                            <span className={`sci_ref_count ${getReferenceInvalid() ? 'sci_ref_count_error' : ''}`}>
                                {t("{{v1}} / {{v2}} selected", artSelectArr.length, selectArticleList.length)}
                            </span>
                        </div>
                    </div>
                    {
                        Boolean(selectLensState) && <Banner
                            tone="warning"
                            onDismiss={() => setSelectLensState('')}
                            title={selectLensState === 'litter' ? t("Please select at least {{v1}} articles.", 2) : t("Please select up to {{v1}} articles.", 5)}
                        ></Banner>
                    }
                    {
                        selectArticleList.length > 0 ? <div className="sci_ref_list">
                            {selectArticleList.map(article => (
                                <div
                                    key={article.id}
                                    className={`sci_ref_item ${artSelectArr.includes(article.id) ? 'selected' : ''}`}
                                    onClick={() => handleToggleReferenceArticle(article.id)}
                                >
                                    <div className="sci_ref_item_main">
                                        <div className="sci_ref_item_check" onClick={(e) => e.stopPropagation()}>
                                            <Checkbox
                                                label=""
                                                labelHidden
                                                checked={artSelectArr.includes(article.id)}
                                                onChange={() => handleToggleReferenceArticle(article.id)}
                                            />
                                        </div>
                                        <div className="sci_ref_item_info">
                                            <Text variant="bodyMd" as="p" fontWeight="medium">{article.title}</Text>
                                            <div className="ellipsis_1">
                                                <a
                                                    href={article.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    onClick={(e) => e.stopPropagation()}
                                                    className="sci_ref_item_url"
                                                >
                                                    {article.url}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sci_ref_item_rank_box">
                                        <span className="sci_ref_item_rank">#{article.position}</span>
                                    </div>
                                </div>
                            ))}
                        </div> : emptyModule("No data to show here")
                    }
                </div>
            </div>
        </Modal.Section>
    </Modal>;

    const SearchIntentModule = <BlockStack gap={400}>
        {
            intentBlockLoading ? <div className='research_content_loading'>
                <BlockStack gap={400}>
                    <Text as='h2' variant='headingMd' fontWeight='bold'>{t("Search Intent")}</Text>
                    <SkeletonBodyText lines={2} />
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <Text as='h3' variant='headingMd' fontWeight='bold'>{t("Competitors' Outlines")}</Text>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <InlineStack gap={100}>
                        <Text as='h3' variant='headingMd' fontWeight='bold'>{t('People Also Ask')}</Text>
                        <Tooltip content={t("Popular questions users ask for this topic, guiding content structure and article FAQs.")}>
                            <span><Icon source={QuestionCircleIcon} tone='subdued' /></span>
                        </Tooltip>
                    </InlineStack>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </div> : <div className='research_content'>
                <BlockStack gap={400}>
                    <InlineStack align='space-between' blockAlign='center' gap={200}>
                        <Text as='h2' variant='headingMd' fontWeight='bold'>{t('Search Intent')}</Text>
                        <Button variant='secondary' size='micro' icon={AdjustIcon} disabled={specialLoading} onClick={handleSelectCompetitorsModal}>{t('Select Competitors')}</Button>
                    </InlineStack>
                    <BlockStack gap={100}>
                        <Text as='p' variant='headingSm' fontWeight='semibold' breakWord>{selectedIntentData?.intent_label}</Text>
                        <InlineStack gap={100} wrap>
                            {/* <Badge tone='success'>{`${selectedIntentData?.percentage ? (Number(selectedIntentData.percentage) * 100).toFixed(0) : '-'}%`}</Badge> */}
                            <Tooltip content={t("The most common page type for this intent. Use this format to maximize your ranking potential.")}>
                                <Badge>{OutIntentType(selectedIntentData?.dominant_page_type || '')}</Badge>
                            </Tooltip>
                        </InlineStack>
                        <Tooltip content={selectedIntentData?.intent_summary}>
                            <div className='ellipsis_2'>
                                <Text as='p' variant='bodyMd' tone='subdued'>{selectedIntentData?.intent_summary}</Text>
                            </div>
                        </Tooltip>
                    </BlockStack>
                    <BlockStack gap={200}>
                        <Text as='h3' variant='headingMd' fontWeight='bold'>{t("Competitors' Outlines")}</Text>
                        <Scrollable >
                            <BlockStack gap={200}>
                                {
                                    (articleList || []).length > 0 ? (articleList).map((item) => {
                                        const open = researchOpenCompetitorId === item.id;
                                        return competitorsWebIds.includes(item.id) ? (
                                            <Box key={item.id} borderWidth='025' borderColor='border' borderRadius='200' padding='0' background='bg-surface'>
                                                <div
                                                    role='button'
                                                    tabIndex={0}
                                                    className={`research_competitor_row_head ${open ? 'is_open' : ''}`}
                                                    onClick={() => setResearchOpenCompetitorId(open ? null : item.id)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            e && e.preventDefault();
                                                            setResearchOpenCompetitorId(open ? null : item.id);
                                                        }
                                                    }}
                                                >
                                                    <Text as='span' variant='bodySm' tone='subdued' fontWeight='semibold'>{`#${item.position}`}</Text>
                                                    <div className='research_competitor_row_body'>
                                                        <Text as='p' variant='bodyMd' fontWeight='semibold' truncate>{item.title}</Text>
                                                        <div className='research_competitor_url' onClick={e => e.stopPropagation()}>
                                                            <Link url={item.url} target='_blank' removeUnderline>{item.url}</Link>
                                                        </div>
                                                    </div>
                                                    <Button icon={open ? ChevronUpIcon : ChevronDownIcon}></Button>
                                                </div>
                                                <Collapsible
                                                    id={`research_competitor_coll_${item.id}`}
                                                    open={open}
                                                    transition={{ duration: '200ms', timingFunction: 'ease-in-out' }}
                                                >
                                                    {
                                                        item.headings_content ? (
                                                            <Scrollable>
                                                                <div className='research_competitor_coll_inner'>
                                                                    {
                                                                        JSON.parse(item.headings_content).map((item, index) => {
                                                                            return <p key={index} className={`research_competitor_item ${Object.keys(item)[0]}`}>
                                                                                {/* 字母大写 */}
                                                                                <Text as='span' variant='bodyXs' tone='subdued'>{Object.keys(item)[0].toUpperCase()}</Text>
                                                                                <Text as='span' variant='bodyMd'>{Object.values(item)[0]}</Text>
                                                                            </p>;
                                                                        })
                                                                    }
                                                                </div>
                                                                <div style={{ padding: '0 16px 8px' }}>
                                                                    <Button fullWidth icon={CopyIcon} onClick={() => handleCopyCompetitorOutline(item.headings_content)}>{t("Copy")}</Button>
                                                                </div>
                                                            </Scrollable>
                                                        ) : <div style={{ borderTop: '1px solid #e3e3e3' }}>{emptyModule("No data to show here")}</div>
                                                    }
                                                </Collapsible>
                                            </Box>
                                        ) : null;
                                    }) : emptyModule("No data to show here")
                                }
                            </BlockStack>
                        </Scrollable>
                    </BlockStack>
                    <div className='paa_list_container'>
                        <BlockStack gap={200}>
                            <InlineStack align='space-between' blockAlign='center' gap={200}>
                                <InlineStack gap={100} blockAlign='center'>
                                    <Text as='h3' variant='headingMd' fontWeight='bold'>{t('People Also Ask')}</Text>
                                    <Tooltip content={t("Popular questions users ask for this topic, guiding content structure and article FAQs.")}>
                                        <span><Icon source={QuestionCircleIcon} tone='subdued' /></span>
                                    </Tooltip>
                                </InlineStack>
                                {
                                    paaData.length > 0 && <Button variant='tertiary' icon={CopyIcon} onClick={handleCopyResearchIntent}>{t('Copy')}</Button>
                                }
                            </InlineStack>
                            {
                                paaData.length > 0 ? <BlockStack gap={100}>
                                    {
                                        paaData.map((q, i) => (
                                            <Text key={i} as='p' variant='bodySm' breakWord>{q}</Text>
                                        ))
                                    }
                                </BlockStack> : emptyModule("No matching PAA found")
                            }
                        </BlockStack>
                    </div>
                </BlockStack>
            </div>
        }
    </BlockStack>;

    return <div>
        {SearchIntentModule}
        {SelectCompetitorsModal}
        {switchTopicTipModal}
    </div>;
};

export default SearchIntent;
